// extracted by mini-css-extract-plugin
export default {"modalWidth":"alertModal_modalWidth__fKRFX"};